import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import CoachList from "@/pages/CoachList";
import Shop from "@/pages/Shop";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";
import SanFranciscoGolfLessons from "@/pages/SanFranciscoGolfLessons";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";
import BookingSuccess from "@/pages/BookingSuccess";
import AdminCoaches from "@/pages/AdminCoaches";
import ProtectedRoute from "@/components/ProtectedRoute";
import CoachFinderWidget from "@/components/CoachFinderWidget";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth return synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/coaches" element={<CoachList />} />
      {/* Legacy routes — Airtable-backed coach/booking pages are retired while we
          migrate to Exonome. Send users to the marketplace handoff page. */}
      <Route path="/coaches/:id" element={<Navigate to="/coaches" replace />} />
      <Route path="/book/:id" element={<Navigate to="/coaches" replace />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/journal" element={<Journal />} />
      <Route path="/journal/:slug" element={<JournalPost />} />
      <Route path="/san-francisco-golf-lessons" element={<SanFranciscoGolfLessons />} />
      <Route path="/admin/coaches" element={<AdminCoaches />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/booking/success" element={<BookingSuccess />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function PublicWidgets() {
  const { pathname } = useLocation();
  return pathname.startsWith("/admin") ? null : <CoachFinderWidget />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <PublicWidgets />
          <Toaster position="top-center" richColors theme="light" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
